function normalizeTechnicalMicrocredentialsPath(
  path: string,
  currentPathname: string,
) {
  // If user is currently in technical-microcredentials section
  if (currentPathname.includes("technical-microcredentials")) {
    // Convert executive-education paths to technical-microcredentials
    return path.includes("executive-education")
      ? path.replace("executive-education", "technical-microcredentials")
      : path;
  }

  // If user is in executive-education section
  return path;
}

export default normalizeTechnicalMicrocredentialsPath;
